import { GoogleTagManager as NextGoogleTagManager } from '@next/third-parties/google';

import { ClientConfig } from '@/services/clientConfig';

interface Props {
  nonce: string | null;
}

export const GoogleTagManager = (props: Props) => {
  const { nonce } = props;

  const clientConfig = ClientConfig.getInstance().getConfig();

  return (
    <NextGoogleTagManager
      gtmId={clientConfig.googleTagManagerId}
      nonce={nonce || undefined}
    />
  );
};
